export default "__VITE_ASSET__9Zgnk9xY__";